import { Component, Input, OnInit } from '@angular/core';
import { Team } from 'src/app/shared/team.model';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';

import { MatDivider } from '@angular/material/divider';
import { TeamPhysicalStatusBlockComponent } from '../team-physical-status-block/team-physical-status-block.component';
import { TeamInjuryBlockComponent } from '../team-injury-block/team-injury-block.component';
import { TeamGamesBlockComponent } from '../team-games-block/team-games-block.component';
import { TeamPhysicalTestBlockComponent } from '../team-physical-test-block/team-physical-test-block.component';

@Component({
    selector: 'app-organization-team-card',
    templateUrl: './organization-team-card.component.html',
    styleUrls: ['./organization-team-card.component.css'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatDivider, TeamPhysicalStatusBlockComponent, TeamInjuryBlockComponent, TeamGamesBlockComponent, TeamPhysicalTestBlockComponent]
})
export class OrganizationTeamCardComponent implements OnInit {

  @Input() Team: Team;
  constructor() { }

  ngOnInit(): void {
    console.log(this.Team);
  }

}
